/**
 * Live upload row counts. Large files skip client-side row counting, so the
 * UI must show worker processedRows even before totalRows is known.
 */
function asCount(value) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

export function formatUploadRowCount({ processedRows, totalRows } = {}) {
  const processed = asCount(processedRows);
  const total = asCount(totalRows);
  if (total && processed) {
    return `${processed.toLocaleString()} uploaded / ${total.toLocaleString()} total`;
  }
  if (total) return `${total.toLocaleString()} total`;
  if (processed) return `${processed.toLocaleString()} uploaded`;
  return "—";
}

export function formatUploadProgressHint({
  processedRows,
  totalRows,
} = {}) {
  const processed = asCount(processedRows);
  const total = asCount(totalRows);
  if (total && processed) {
    return `Uploaded ${processed.toLocaleString()} / Total ${total.toLocaleString()}`;
  }
  if (total) return `Total ${total.toLocaleString()}`;
  if (processed) return `Uploaded ${processed.toLocaleString()}`;
  return "";
}
